import { render, staticRenderFns } from "./ProductorOrigin.vue?vue&type=template&id=774467be&scoped=true&"
import script from "./ProductorOrigin.vue?vue&type=script&lang=js&"
export * from "./ProductorOrigin.vue?vue&type=script&lang=js&"
import style0 from "./ProductorOrigin.vue?vue&type=style&index=0&id=774467be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774467be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow})
